import { useSearchParams } from "react-router-dom";
import { AlertCircle } from "untitledui-js-base";
import { Button, ButtonSize, ButtonVariant } from "shared/components/Button";
import { Show } from "shared/components/helpers/Show";
import { VerificationNames } from "shared/types";

interface WarningsReportBlockedViewProps {
  idvOverrideRequired?: boolean;
}

export const WarningsReportBlockedView = ({
  idvOverrideRequired
}: WarningsReportBlockedViewProps) => {
  const [, setSearchParams] = useSearchParams();

  const goToReport = (report: VerificationNames) => () =>
    setSearchParams(
      (prev) => {
        const next = new URLSearchParams(prev);
        next.set("report", report);
        return next;
      },
      { replace: true }
    );

  return (
    <div className="mx-auto flex w-[432px] flex-col items-center gap-6 pt-16 text-center">
      <div className="flex size-[100px] items-center justify-center rounded-full bg-danger-50">
        <AlertCircle className="stroke-danger-500" size="40px" />
      </div>

      <div className="w-full">
        <p className="text-sm font-semibold text-content-500">
          Unable to run this report
        </p>
        <p className="mt-2 text-sm font-medium leading-5 text-content-300">
          {idvOverrideRequired
            ? "Identity verification and the warnings report have failed. To proceed, override both reports."
            : "The warnings report has failed. To proceed, override the warnings report."}
        </p>
      </div>

      <div className="flex flex-wrap justify-center gap-2">
        <Show if={Boolean(idvOverrideRequired)}>
          <Button
            size={ButtonSize.SM}
            variant={ButtonVariant.BASE}
            onClick={goToReport(VerificationNames.IdentityVerification)}
          >
            Go to Identity verification
          </Button>
        </Show>

        <Button
          size={ButtonSize.SM}
          variant={ButtonVariant.BASE}
          onClick={goToReport(VerificationNames.WarningsReport)}
        >
          Go to Warnings report
        </Button>
      </div>
    </div>
  );
};
